import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { fetchData } from "./utils";
import { NavLink } from "react-router-dom";
const Latest_Product = () => {
  const [mainList, setMainList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [logosByCategory, setLogosByCategory] = useState({});
  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/feature/aproved/all/adds";
      const result = await fetchData(url);
      if (result && result.data) {
        // console.log(result.data)
        const categorizedproduct = {};
        result.data.forEach((item) => {
          const categoryTitle = item.category?.title;
          if (!categorizedproduct[categoryTitle]) {
            categorizedproduct[categoryTitle] = [];
          }
          categorizedproduct[categoryTitle]?.push({
            id: item.id,
            img: item.media[0]?.original_url,
            title: item?.title,
            description: item?.short_description,
            email: item?.email,
            slug: item?.slug
          });
        });
        setMainList(result.data);
        setCategories(Object.keys(categorizedproduct));
        setLogosByCategory(categorizedproduct);
        setSelectedCategory(Object.keys(categorizedproduct)[0]);
      }
    };
    fetchApiData();
  }, []);


  return (
    <>
      <section className="buy py-5">
        <div className="container">
          <div className="">
            <h1 className="text-center">Latest Product</h1>
            <div className="row">
              <div className="d-flex align-items-center flex-wrap justify-content-center gap-2 my-5">
                {categories.map((category, index) => (
                  <button
                    key={index}
                    className={`tabs-btns ${selectedCategory === category ? "active" : ""
                      }`}
                    onClick={() => setSelectedCategory(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
              {logosByCategory[selectedCategory]?.slice(0, 8).map((details, index) => (
                <div className="col-md-3 mb-2" key={index}>
                  <NavLink to={`/ad/${details.slug}`}>
                    <div className="card h-100">
                      <div className="card-img-wrapper">
                        <img src={details.img} alt={details.title} />
                      </div>
                      <div className="card-body ">
                        <h6 className="card-title text-center">{details.title}</h6>
                        <p className="small product-card-description line-clamp-3">{details.description}</p>
                        <strong className="">{details.email}</strong>
                      </div>
                    </div>
                  </NavLink>
                </div>
              ))}
            </div>
          </div>
          {logosByCategory[selectedCategory]?.length > 8 && (
            <div className="row">
              <div className="mt-4 text-center">
                <NavLink to='/ad'>
                  <button className="custom-button">View All</button>
                </NavLink>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Latest_Product;
